import CoreAPI from "../coreAPI";
import DashboardMetrics, {
  DashboardMetricsAPIResponse,
} from "../../classes/employerDashboard/metrics/dashboardMetrics";

export default function APIMetrics(coreAPI: CoreAPI) {
  return {
    async getDashboard(year: number) {
      try {
        return DashboardMetrics.fromAPI(
          await coreAPI.authCall<DashboardMetricsAPIResponse>({
            endpoint: `/tenant/metrics/${year}`,
          })
        );
      } catch (e) {
        return new DashboardMetrics({});
      }
    },
  };
}
